export class SignedOutError extends Error {
  public url: string;

  constructor(message: string, url: string) {
    super(message);
    this.url = url;
    this.name = this.constructor.name;

    Object.setPrototypeOf(this, new.target.prototype);
  }

  static isInstance(error: unknown): boolean {
    return error instanceof SignedOutError;
  }
}
